"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BundleVersionWidget = void 0;
// eslint-disable-next-line import/no-cycle
const BundleVersionWidget_1 = __importDefault(require("./BundleVersionWidget"));
exports.BundleVersionWidget = BundleVersionWidget_1.default;
exports.default = BundleVersionWidget_1.default;
